import { FC } from "react";

const Break: FC = () => {
  return (
    <>
      <svg
        className="min-w-24px"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 3.5H4V13.5C4 15.71 5.79 17.5 8 17.5H14C16.21 17.5 18 15.71 18 13.5V10.5H20C21.11 10.5 22 9.6 22 8.5V5.5C22 4.39 21.11 3.5 20 3.5ZM20 8.5H18V5.5H20V8.5ZM4 19.5H20V21.5H4V19.5Z"
          fill="#167E76"
        />
      </svg>
    </>
  );
};

export default Break;
